import React from 'react'
import { Subscription } from '../../../types/Subscription'
import { useAdmin } from '../../../contexts/AdminContext'
import Heading from '../../../components/Heading'
import { useTranslation } from 'react-i18next'
import cx from 'classnames'
import styles from './SubscriptionTable.module.css'
import { useNavigate } from 'react-router-dom'

const SubscriptionTable: React.FC<{ subscriptions: Subscription[] }> = ({
    subscriptions,
}) => {
    const { chooseSub } = useAdmin()
    const { t } = useTranslation(['settings'])
    const navigate = useNavigate()

    return (
        <div className={'zr-mt-6'}>
            <Heading level={3}>{t('subscription.yourSubs')}</Heading>
            <table className={'zr-w-100'}>
                <thead className={cx(styles['row'])}>
                    <tr>
                        <th>{t('subscription.products')}</th>
                        <th>{t('subscription.key')}</th>
                        <th>Host</th>
                        <th>Status</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {subscriptions.map((sub) => {
                        return (
                            <tr key={sub.stripe_id} className={'zr-mb-3'}>
                                <td>
                                    <ul className={cx(styles['list'])}>
                                        {sub.plans.map((plan) => {
                                            return (
                                                <li key={plan.id}>
                                                    {plan.name} (
                                                    {plan.price
                                                        .toString()
                                                        .replace('.', ',') +
                                                        ' €'}
                                                    )
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </td>
                                <td>{sub.stripe_id}</td>
                                <td>{sub.host}</td>
                                <td>
                                    {sub.stripe_status === 'active' &&
                                        !sub.end_date &&
                                        t('subscription.statusValues.active')}
                                    {sub.stripe_status === 'active' &&
                                        sub.end_date &&
                                        t(
                                            'subscription.statusValues.active_until',
                                            { date: sub.end_date }
                                        )}
                                    {sub.stripe_status === 'canceled' &&
                                        t('subscription.statusValues.canceled')}
                                    {sub.stripe_status === 'past_due' &&
                                        t('subscription.statusValues.past_due')}
                                    {sub.stripe_status === 'incomplete' &&
                                        t(
                                            'subscription.statusValues.incomplete'
                                        )}
                                </td>
                                <td>
                                    <div
                                        className={
                                            'zr-d-flex zr-w-100 zr-justify-end'
                                        }
                                    >
                                        <u
                                            className={
                                                'zr-font-weight-bold zr-cursor-pointer'
                                            }
                                            onClick={() => {
                                                chooseSub(sub)
                                                navigate(
                                                    '/subscription/change-plan'
                                                )
                                            }}
                                        >
                                            {t('subscription.change')}
                                        </u>
                                    </div>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}

export default SubscriptionTable
